import { useEffect, useRef } from 'react';
import { generatePath, useNavigate, useParams } from 'react-router';

import { usePaths } from './hooks';

type IOrderId = { orderId: string };
type IRef = { shipmentReference: string };

function useRedirect(path: string, params: Record<string, string | number | boolean | undefined>, replace: boolean) {
    // I use the ref to get a last redirect value and avoid redirect again to the same page and enter in a
    // infinite loop. For example if some changes and we rerender the component. More common in tests
    const lastRedirect = useRef<string | null>(null);
    const navigate = useNavigate();
    const tenantParams = useParams();

    useEffect(() => {
        const newPath = generatePath(path, { ...tenantParams, ...params });

        if (lastRedirect.current !== newPath) {
            navigate(newPath, { replace });
            lastRedirect.current = newPath; // Store last redirection to avoid new redirection in future re-renders
        }
    }, [path, params, replace, tenantParams, navigate, lastRedirect]);
}

export const ReplaceByPostSalePage = ({ shipmentReference = 'error' }: IRef): null => {
    const paths = usePaths();
    useRedirect(paths.POST_SALE, { shipmentReference }, true);
    return null;
};

export const ReplaceByCheckoutPage = ({ orderId }: IOrderId): null => {
    const paths = usePaths();
    useRedirect(`${paths.CHECKOUT}?orderId=${orderId}`, {}, true);
    return null;
};
